module.exports = __webpack_public_path__ + "07_long_brown.c312839e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/07_long_brown.png
// module id = 8Omp
// module chunks = 0